import { CeremonialPanelFrame, OrnateControlFrame, RibbonFrame } from '../components/CeremonialFrames';
import { ExperienceDisclaimer } from '../components/ExperienceDisclaimer';

function ClockIcon() {
  return <svg viewBox="0 0 28 28" aria-hidden="true"><circle cx="14" cy="14" r="10" /><path d="M14 8v7l4 2" /><path d="M9 3h10" /></svg>;
}

function ScrollIcon() {
  return <svg viewBox="0 0 28 28" aria-hidden="true"><path d="M8 4h13v17H8z" /><path d="M11 9h7M11 13h7M11 17h4" /><path d="M5 7v17h13" /></svg>;
}

export function HomePage({ onStart }: { onStart: () => void }) {
  return (
    <main className="public-page home-page">
      <img className="public-stage-art" src="/assets/public/public-stage-reference-v2.webp" alt="" width="941" height="1672" fetchPriority="high" decoding="sync" />
      <section className="ceremonial-panel home-panel" aria-labelledby="home-title">
        <CeremonialPanelFrame />
        <div className="ceremonial-content">
          <h1 id="home-title" className="sr-only">你命中注定的盖世英雄是谁？</h1>
          <img className="public-calligraphy home-calligraphy" src="/assets/public/titles/home-title-v3.webp" alt="" width="800" height="291" fetchPriority="high" decoding="sync" />
          <div className="ceremonial-ribbon home-ribbon">
            <RibbonFrame />
            <span>28 个选择，看看谁最符合你的关系需求</span>
          </div>
          <button className="ornate-primary-button home-start-button" type="button" onClick={onStart}>
            <OrnateControlFrame tone="rose" />
            <span>开始测试</span>
            <i className="button-blossom" aria-hidden="true">✿</i>
          </button>
          <div className="home-meta" aria-label="测试信息">
            <span><ClockIcon /><b>约5分钟</b></span>
            <span><ScrollIcon /><b>共28题</b></span>
          </div>
          <ExperienceDisclaimer className="home-disclaimer" />
        </div>
      </section>
    </main>
  );
}
